import { VideoEditor } from '../components/VideoEditor';

export default function VideoPromoPage() {
  return <VideoEditor style="promo" />;
}
